import { render, staticRenderFns } from "./ReprintedFrom.vue?vue&type=template&id=639e370c&scoped=true"
import script from "./ReprintedFrom.vue?vue&type=script&lang=js"
export * from "./ReprintedFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e370c",
  null
  
)

export default component.exports